module.exports = __webpack_public_path__ + "static/media/date-time-preview.280da856.png";